import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import EditPlayer from "../views/EditPlayer.vue";
import PlayerLobby from "../views/PlayerLobby.vue";
import Game from "../views/Game.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/player/edit/:id",
    name: "EditPlayer",
    component: EditPlayer,
    props: true,
  },
  {
    path: "/player/lobby",
    name: "PlayerLobby",
    component: PlayerLobby,
  },
  {
    path: "/game",
    name: "Game",
    component: Game,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Privacy.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.onError(() => {});

export default router;
